webpackJsonp([206320826777666],{

/***/ 1589:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/lowdamage/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-lowdamage-33c26cd50d7f607a7054.js